import React, { useContext } from 'react';
import { ekanalys_ekanalys_columns } from '../../../../../../../../Queries/EkonomiskAnalysSettingsQuery/_QueryTypes/ekanalys';
import { ApolloClient, ApolloConsumer } from '@apollo/client';
import {
  IColumnCaptionQueryVariables,
  IColumnCaptionQueryData,
} from './EkonomiskAnalysEditColumnCaptionQuery';
import { EkonomiskAnalysSideMenuContext } from '../../../../../../Context/EkonomiskAnalysSideMenuContext';
import { ISelectedAnalys } from '../../../../../../../../EkonomiskAnalysPage';
import { ILocalAnalys } from '../../../../../../../EkonomiskAnalysMain/EkonomiskAnalysMain';
import columnCaptionQuery from '../../../../../../../../Queries/EkonomiskAnalysColumnCaptionQuery/EkonomiskAnalysColumnCaptionQuery.gql';
import { EkonomiskAnalysColumnCaptionQuery_ekanalyskolumninfoperanalys_columns } from '../../../../../../../../Queries/EkonomiskAnalysColumnCaptionQuery/_QueryTypes/EkonomiskAnalysColumnCaptionQuery';
import Logger, {
  graphQLError,
} from '../../../../../../../../../../../../../Utils/Logger';
import { getColumnName } from '../../../../../../../../Queries/EkonomiskAnalysColumnCaptionQuery/EkonomiskAnalysColumnCaptionQuery';
import { GraphQLError } from 'graphql';
import { INewColumnData } from '../../EkonomiskAnalysEditColumnDialog/EkonomiskAnalysEditColumnDialog';
import {
  colToInputCol,
  datesToPartialTimeInterval,
} from '../../../../../../../../Utils/convertUtils';

interface IProps {
  newColumnData: INewColumnData;
  children: (
    getColumnDisplayLabel: getColumnDisplayLabelType
  ) => React.ReactNode;
}

interface IInnerProps extends IProps {
  client: ApolloClient<any>;
  selectedAnalys: ISelectedAnalys | null;
  newAnalysSettings: ILocalAnalys;
}

export type getColumnDisplayLabelType = (
  column?: ekanalys_ekanalys_columns
) => Promise<string>;

const getColumnDisplayLabelFromCaption = (
  errors?: ReadonlyArray<GraphQLError>,
  caption?: EkonomiskAnalysColumnCaptionQuery_ekanalyskolumninfoperanalys_columns
): string => {
  if (errors && errors.length > 0) {
    Logger.error(graphQLError(errors));
    return 'Kunde inte hämta rubrik';
  } else if (caption == null) {
    Logger.error(new Error('Caption is null'));
    return 'Kunde inte hämta rubrik';
  } else {
    return getColumnName(caption);
  }
};

class EkonomiskAnalysEditColumnManualCaptionQuery extends React.Component<IInnerProps> {
  getColumnDisplayLabel: getColumnDisplayLabelType = column => {
    const variables = {
      analys: {
        columns: column ? [colToInputCol(column)] : [],
        name: 'Namnlös kolumn',
        sums: null,
      },
      codePrivilegeId: this.props.newColumnData.codePrivilegeId,
      tidsintervall: datesToPartialTimeInterval(
        this.props.newAnalysSettings.dates,
        this.props.newAnalysSettings.isInterval
      ),
    };
    return this.props.client
      .query<IColumnCaptionQueryData, IColumnCaptionQueryVariables>({
        query: columnCaptionQuery,
        variables: variables,
      })
      .then(({ data, errors }) => {
        const caption =
          data &&
          data.ekanalyskolumninfoperanalys &&
          data.ekanalyskolumninfoperanalys.columns
            ? data.ekanalyskolumninfoperanalys.columns[0]
            : undefined;
        const displayLabel = getColumnDisplayLabelFromCaption(errors, caption);
        return displayLabel;
      });
  };

  render() {
    return this.props.children(this.getColumnDisplayLabel);
  }
}

const EnhancedEkonomiskAnalysEditColumnManualCaptionQuery: React.FunctionComponent<
  IProps
> = props => {
  const { selectedAnalys, newAnalysSettings } = useContext(
    EkonomiskAnalysSideMenuContext
  );
  return (
    <ApolloConsumer>
      {client => (
        <EkonomiskAnalysEditColumnManualCaptionQuery
          {...props}
          client={client}
          selectedAnalys={selectedAnalys}
          newAnalysSettings={newAnalysSettings}
        />
      )}
    </ApolloConsumer>
  );
};

export default EnhancedEkonomiskAnalysEditColumnManualCaptionQuery;
